<template>
      <canvas v-if="renderComponent" :id="guid" :ref="guid" />
</template>

<script>
import Chart from 'chart.js/auto';
let grapharea;
let myChart;
export default {
      props: {
            chartdata: {
                  type: Object,
                  default: null
            },
            computedOptions: {
                  type: Object,
                  default: null
            },
            guid: {
                  type: String,
                  required: true,
            }
      },
      data(){
            return {
                  renderComponent: true,
                  op: null,
                  chart_bg: ["rgba(251, 224, 37, 1)", "rgba(0, 40, 58, 1)","rgba(123, 152, 172, 1)","rgba(226, 226, 226, 1)","rgba(241, 242, 242, 1)"],
                  chart_border: ["rgba(251, 224, 37, 0.5)", "rgba(0, 40, 58, 0.5)","rgba(123, 152, 172, 0.5)","rgba(226, 226, 226, 0.5)","rgba(241, 242, 242, 0.5)"],
                  chart_bg_line: ["rgba(251, 224, 37, 1)", "rgba(0, 40, 58, 1)","rgba(123, 152, 172, 1)","rgba(226, 226, 226, 1)","rgba(241, 242, 242, 1)"],
                  options: {
                        indexAxis: 'x',
                        elements: {
                              bar: {},
                              // points: {
                              //       borderColor: this.chart_bg_line,
                              //       pointStyle: 'cross'
                              // },
                        },
                        backgroundColor: 'rgba(255, 99, 132, 0.2)',
                        borderColor: 'rgba(255, 99, 132, 1)',
                        responsive: this.computedOptions.responsive,
                        maintainAspectRatio: this.computedOptions.responsive ? false : true,
                        plugins: {
                              legend: {
                                    display: true,
                                    position: 'top',
                                    labels: {
                                          boxWidth: 20,
                                          boxHeight: 20
                                    }
                              },
                        },
                        scales: {
                        }
                  }
            }
      },
      computed:{
            data(){
                  let output = this.chartdata
                  output.datasets.forEach((element, index) => {
                        delete element.backgroundColor
                        element.borderWidth = 0;
                        element.barThickness = 12;
                        element.label = element.label ? element.label : `Dataset ${index + 1}`;
                  });
                  return output
            },
            showLegend(){
                  return this.computedOptions.showLegend;
            },
            legendPosition(){
                  return this.computedOptions.legendPosition;
            },
            axis(){
                  return this.computedOptions.indexAxis;
            }
      },
      methods: {
            addMissingChartColours(){
                  function random_rgba() {
                        const o = Math.round,
                              r = Math.random,
                              s = 255,
                              opacities = ['1','0.5','0.1'],
                              output = [],
                              color = o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s);
                        for(let opacity of opacities){
                              output.push('rgba(' + color + ',' + opacity + ')')
                        }
                        return output;
                  }
                  //check number of labels to create more colours if exceded number of predefined colours for chart_bg, chart_border and chart_bg_line
                  if(this.data){
                        const labels_count = this.data.labels.length
                        let missing_colors_count = this.chart_bg.length - labels_count
                        if(missing_colors_count < 0) {
                              for(let a = 0; a < Math.abs(missing_colors_count); a++){
                                    const color = random_rgba()
                                    this.chart_bg.push(color[0])
                                    this.chart_border.push(color[1])
                                    this.chart_bg_line.push(color[2])
                              }
                        }
                  }
            },
            reoptions(){
                  let options = this.options;
                  options.plugins.legend.display = this.showLegend
                  options.plugins.legend.position = this.legendPosition
                  options.indexAxis = this.axis
                  options.elements.bar.backgroundColor = this.chart_bg
                  options.elements.bar.borderColor = this.chart_border
                  options.elements.bar.borderWidth = 0
                  options.elements.bar.borderRadius = 12
                  options.scales = {}
                  this.op = options
            },
            chartObject(){
                  this.renderComponent = false;
                  this.$nextTick().then(() => {
                        this.renderComponent = true;
                        setTimeout(() => {
                              if(document.getElementById(this.guid)){
                                    grapharea = document.getElementById(this.guid).getContext("2d");
                                    this.reoptions();
                                    myChart = new Chart(grapharea, {
                                          type: 'bar',
                                          data: this.data,
                                          options: this.op
                                    });
                              }
                        },0)
                  })
            }
      },
      watch: {
            showLegend: {
                  handler: function (){
                        myChart.destroy()
                        this.chartObject()
                  }
            }, 
            legendPosition: {
                  handler: function (){
                        myChart.destroy()
                        this.chartObject()
                  }
            }, 
            axis: {
                  handler: function (){
                        myChart.destroy()
                        this.chartObject()
                  }
            }, 
      },
      mounted () {
            grapharea = document.getElementById(this.guid).getContext("2d");
            this.addMissingChartColours()
            this.chartObject()
            
      }
}
</script>
